import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { loginPath } from '@vigilo/security';
import { TOKEN_KEY } from '@vigilo/api-client';

export function ProtectedRoute() {
  const location = useLocation();
  const token = localStorage.getItem(TOKEN_KEY());
  if (!token) {
    if (location.pathname.startsWith('/ci')) return <Navigate to={loginPath('ci')} replace />;
    if (location.pathname.startsWith('/border')) return <Navigate to={loginPath('border')} replace />;
    if (location.pathname.startsWith('/forensics')) return <Navigate to={loginPath('forensics')} replace />;
    if (location.pathname.startsWith('/intel')) return <Navigate to={loginPath('intel')} replace />;
    return <Navigate to={loginPath('crowd')} replace />;
  }
  return <Outlet />;
}
